import { render } from "./data-usage.vue?vue&type=template&id=6aba62fc&ts=true"
import script from "./data-usage.vue?vue&type=script&lang=ts"
export * from "./data-usage.vue?vue&type=script&lang=ts"

import "./data-usage.vue?vue&type=style&index=0&id=6aba62fc&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__